import { message } from "antd";
import axios, { AxiosInstance, AxiosResponse, AxiosHeaderValue } from "axios";
// import { baseURL } from "./baseURL";
import { getStorage, removeStorage, setStorage } from "./common";

axios.defaults.timeout = 100000;
// axios.defaults.baseURL = baseURL;

// 请求拦截器
const http: AxiosInstance = axios.create({
  baseURL: "/admin", // 代理地址
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: getStorage("Authorization") as AxiosHeaderValue,
  },
});

// 每次请求读取当前会话，避免登录后仍使用初始化时的 token。
http.interceptors.request.use((config) => {
  const token = getStorage("Authorization");
  if (typeof token === "string") config.headers.set("Authorization", token);
  else config.headers.delete("Authorization");
  return config;
});

function expireSession(): void {
  message.error("登录过期，请重新登录");
  removeStorage("Authorization");
  removeStorage("storeOpenKeys");
  setStorage("memberUserList", []);
  setTimeout(() => {
    window.location.href = window.location.origin + "#/login";
    window.location.reload();
  }, 300);
}

function getResponseError(data: unknown): { code?: number; msg?: string } {
  if (typeof data !== "object" || data === null) return {};
  return {
    code:
      "code" in data && typeof data.code === "number" ? data.code : undefined,
    msg: "msg" in data && typeof data.msg === "string" ? data.msg : undefined,
  };
}

http.interceptors.response.use(
  async (res: AxiosResponse): Promise<AxiosResponse> => {
    // 识别导出接口的业务错误，同时保留旧接口合法的 CSV/文本文件。
    if (res.data instanceof Blob && /json|text\//i.test(res.data.type)) {
      const file = res.data;
      const merchantExport =
        res.config.url === "/shop/merchant/withdraw/export";
      let payload: unknown;
      try {
        payload = JSON.parse(await file.text());
      } catch {
        if (merchantExport) {
          message.error("导出失败，服务未返回 Excel 文件");
          throw new Error("导出失败，服务未返回 Excel 文件");
        }
      }
      const { code } = getResponseError(payload);
      if (code !== undefined && code !== 200) res.data = payload;
      else if (merchantExport) {
        message.error("导出失败，服务未返回 Excel 文件");
        throw new Error("导出失败，服务未返回 Excel 文件");
      }
    }
    const { code, msg } = getResponseError(res.data);
    if (code === undefined || code === 200) return res.data;
    if (code === 401) expireSession();
    else if (code === 403) {
      if (!res.config.url?.includes("/index/statistics/0")) {
        message.error(msg || "当前登录用户没有权限，请联系管理员获取权限");
      }
    } else message.error(msg || "操作失败");
    throw Object.assign(new Error(msg || "请求失败"), {
      status: res.status,
      data: res.data,
    });
  },
  async (error: unknown): Promise<never> => {
    if (axios.isCancel(error)) throw error;
    if (axios.isAxiosError(error)) {
      let payload: unknown = error.response?.data;
      if (payload instanceof Blob && /json|text\//i.test(payload.type)) {
        try {
          payload = JSON.parse(await payload.text());
        } catch {
          payload = undefined;
        }
      }
      const { msg, code } = getResponseError(payload);
      if (error.response?.status === 401 || code === 401) expireSession();
      else
        message.error(
          msg ||
            (error.response?.status === 403
              ? "当前登录用户没有权限，请联系管理员获取权限"
              : "网络异常，请稍后重试")
        );
      throw Object.assign(new Error(msg || error.message), {
        status: error.response?.status,
        data: payload,
      });
    }
    message.error("系统异常");
    throw error;
  }
);

export default http;
